// extracted by mini-css-extract-plugin
module.exports = {"table-requests":"SortableTableRequests_table-requests__iuGcI","request-status":"SortableTableRequests_request-status__1GxmA"};